/* eslint-disable */

import Component from 'gia/Component'

export default class AddToList extends Component {
  constructor(element) {
    super(element)
    this.mainElement = $(this.element)
    this.listContainer = this.mainElement.find('.m-my-lists')
    this.listHeading = this.mainElement.find('.m-my-lists__heading')
    this.buttons = this.mainElement.find('> a')
    this.labels = this.mainElement.find('.list-label')
    this.purposeContainer = this.listContainer.find('.m-my-lists-purpose')
    this.btnBack = this.listContainer.find('.m-my-lists-purpose__back')
    this.purposeForm = this.purposeContainer.find('.m-my-lists-purpose__form')
    this.parentContainer = this.toggleList = this.mainElement[0].closest(
      '.m-incentive-tile'
    )
    this.messagePopup = this.mainElement[0].querySelector('.m-my-lists-alert')
    if (this.parentContainer)
      this.toggleList = this.parentContainer.querySelector('.m-toggle-list')
    this.purpose = []
  }

  init() {
    // get list data
    this.getListData()
    //reset all
    this.resetAll()
    // render all
    this.renderAll()
  }

  getActivePurposeData() {
    const listActive = this.purposeForm[0].querySelectorAll(
      '.purpose-checkbox-list__active'
    )
    if (listActive.length === 0) {
      this.purpose = []
      return []
    }
    const purposeList = []
    listActive.forEach(el => {
      purposeList.push(el.dataset.purpose)
    })
    this.purpose = purposeList
    return purposeList
  }

  getListData() {
    const data = this.mainElement.attr('data-list')
    this.listData = JSON.parse(data)
    if (this.listData.length > 0) this.uid = this.listData[0].uid
  }

  resetLabelList() {
    const labels = this.mainElement[0].querySelectorAll('.list-label')
    labels.forEach(e => {
      e.classList.remove('list-label-active')
      $(e).show()
      e.querySelector('a').setAttribute('data-status', 'false')
    })
    this.listHeading.show()
  }

  resetLabelListAdded() {
    const listLabel = this.mainElement[0].querySelectorAll('.list-label-added')
    if (listLabel.length > 0) {
      listLabel.forEach(e => {
        e.classList.remove('list-label-added')
      })
    }
  }

  resetPurposeList() {
    const purposeList = this.purposeForm[0].querySelectorAll(
      '.purpose-checkbox-list'
    )
    purposeList.forEach(e => {
      e.setAttribute('data-status', 'false')
      e.classList.remove('purpose-checkbox-list__active')
    })
  }

  resetLikeIcon() {
    // console.log(this.toggleList)
    this.mainElement[0].setAttribute('data-status', false)
    if (this.toggleList) this.toggleList.setAttribute('data-status', false)
  }

  renderLikeIcon() {
    const listLabel = this.mainElement[0].querySelectorAll('.list-label-added')
    if (listLabel.length > 0) {
      this.mainElement[0].setAttribute('data-status', true)
      if (this.toggleList) this.toggleList.setAttribute('data-status', true)
    }
  }

  resetAll() {
    this.hideMylist()
    this.hidePurposeForm()
    this.resetLabelList()
    this.resetLabelListAdded()
    this.resetPurposeList()
    this.resetLikeIcon()
  }

  renderAll() {
    // render label list
    this.renderLabelList()
    // render like icon
    this.renderLikeIcon()
  }

  renderLabelList() {
    if (this.listData.length === 0) return
    const listLabel = this.mainElement[0].querySelectorAll('.list-label')
    listLabel.forEach(e => {
      const listId = e.dataset.list
      this.listData.forEach(list => {
        if (list['lid'] == listId) {
          // e.setAttribute('data-status', 'true')
          // e.classList.add('purpose-checkbox-list__active')
          const listLabel = this.mainElement[0].querySelector(
            `.list-label[data-list="${listId}"]`
          )
          // if (!listLabel.classList.contains('list-label-active'))
          //   listLabel.classList.add('list-label-active')
          listLabel.classList.add('list-label-added')
        }
      })
    })
  }

  resetActivePurpose() {
    this.purposeForm[0].setAttribute('data-status', false)
    this.purposeForm[0].querySelector('.btn-submit').textContent = 'Add'
    this.isUpdate = false
  }

  renderActivePurpose(listId) {
    const purposeList = this.purposeForm[0].querySelectorAll(
      '.purpose-checkbox-list'
    )
    // const otherLabels = this.mainElement[0].querySelectorAll(
    //   `.list-label[data-list]:not([data-list="${listId}"])`
    // )
    const otherLabels = this.mainElement[0].querySelectorAll('.list-label')
    otherLabels.forEach(e => {
      $(e).hide()
    })

    if (this.listData.length === 0) return
    this.resetPurposeList()
    purposeList.forEach(e => {
      const purpose = e.dataset.purpose
      this.listData.forEach(list => {
        if (list['lid'] == listId && list['purpose'].includes(purpose)) {
          this.isUpdate = true
          this.purposeForm[0].setAttribute('data-status', true)
          this.purposeForm[0].querySelector('.btn-submit').textContent =
            'Update'
          e.setAttribute('data-status', 'true')
          e.classList.add('purpose-checkbox-list__active')
        }
      })
    })
  }

  addMemberToList(isAdd) {
    const listEl = $('.list-label-active').find('a')
    let myAction = isAdd ? 'add' : 'remove'
    if (this.isUpdate) myAction = 'update'
    if (this.purpose.length === 0) myAction = 'remove'

    //data fed to ajax query
    const myData = {
      list: listEl.attr('data-list'),
      item: { id: this.mainElement.attr('data-item'), purpose: this.purpose },
      action: myAction,
    }

    $.ajax({
      url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'ajax_request',
        item: myData.item,
        list: myData.list,
        do: myData.action,
      },
      beforeSend: () => {
        this.listContainer.addClass('m-my-lists--updating')
      },
      success: result => {
        // if (myAction == 'add') {
        //   listEl.attr('data-status', 'true')
        // }
        // if (myAction == 'remove') {
        //   listEl.attr('data-status', 'false')
        // }

        //see if any lists are still active for this object
        // let pinStatus = this.mainElement.find(
        //   '.list-label a[data-status="true"]'
        // )

        // if (pinStatus.length > 0) {
        //   this.mainElement.attr('data-status', 'true')
        // } else {
        //   this.mainElement.attr('data-status', 'false')
        // }
        // this.listContainer.fadeOut(150)

        this.listContainer[0].classList.remove('make-flex')

        this.mainElement[0].classList.remove('addZIndex')

        let newListData = [...this.listData]
        const newData = {
          uid: this.uid,
          lid: myData.list,
          mid: myData.item.id,
          purpose: myData.item.purpose,
        }

        if (newData.purpose.length > 0) {
          const existingDataIndex = newListData.findIndex(
            l => l.lid == newData.lid
          )
          if (existingDataIndex > -1) {
            newListData[existingDataIndex] = newData
          } else {
            newListData.push(newData)
          }
        } else {
          newListData = this.listData.filter(l => l.lid != newData.lid)
        }

        this.listData = newListData

        this.resetAll()
        this.renderAll()
      },
      complete: () => {
        this.listContainer.removeClass('m-my-lists--updating')
      },

      error: () => {
        this.listContainer.removeClass('m-my-lists--updating')
        this.listContainer.addClass('m-my-lists--error')
      },
    })
  }

  removeActiveLabels() {
    document.querySelectorAll('.m-my-lists .list-label').forEach(e => {
      e.classList.remove('list-label-active')
    })
  }

  hideMylist() {
    const myListContainer = document.querySelectorAll('.m-my-lists')
    myListContainer.forEach(el => {
      this.listContainer[0].classList.remove('make-flex')
    })

    this.mainElement[0].classList.remove('addZIndex')
  }

  hidePurposeForm() {
    this.purposeContainer.hide()
  }

  mount() {
    this.init()
    //show your options for a given post
    this.buttons.click(e => {
      e.preventDefault()
      // this.hideMylist()
      if (this.listContainer[0].classList.contains('make-flex')) {
        this.listContainer[0].classList.remove('make-flex')
      } else {
        this.listContainer[0].classList.add('make-flex')
      }
      // this.listContainer.fadeToggle()
      this.resetLabelList()
      this.hidePurposeForm()
    })

    // hide the list box if you click out of the element (or on another list selector)
    document.querySelector('body').addEventListener('click', e => {
      const target = e.target.closest('.m-add-to-list')
      const toggle = e.target.closest('.m-toggle-list')
      if (target || toggle) return
      this.hideMylist()
      this.resetLabelList()
    })

    this.labels.find('a').click(e => {
      e.preventDefault()
      // this.removeActiveLabels()
      const listLabel = e.target.closest('.list-label')
      if (!listLabel) return
      if (listLabel.classList.contains('list-label-active')) {
        listLabel.classList.remove('list-label-active')
        e.target.setAttribute('data-status', false)
      } else {
        listLabel.classList.add('list-label-active')
        e.target.setAttribute('data-status', true)
      }
      this.listId = e.target.dataset.list
      this.resetActivePurpose()
      this.renderActivePurpose(this.listId)
      this.purposeContainer.show()
      this.listHeading.hide()
      this.btnBack.find('span').text(listLabel.querySelector('a').textContent)
    })

    this.purposeForm.on('click', e => {
      e.preventDefault()
      const purposeList = e.target.closest('li.purpose-checkbox-list')
      const submitButton = e.target.closest('.btn-submit')
      const removeButton = e.target.closest('.btn-remove')
      if (submitButton) {
        if (
          !this.getActivePurposeData().length &&
          document.querySelector('.page-template')
        ) {
          this.messagePopup.classList.remove('hide')
          return
        }
        if (
          !this.getActivePurposeData().length &&
          document.querySelector('.single-suppliers')
        ) {
          document.querySelector('.m-my-lists-alert-2').classList.remove('hide')
          return
        }
        this.addMemberToList(true)
        return
      }
      if (removeButton) {
        this.resetPurposeList()
        this.purpose = []
        this.addMemberToList(false)
      }
      if (!purposeList) {
        return
      }
      const status = purposeList.dataset.status
      if (status == 'false') {
        purposeList.setAttribute('data-status', 'true')
        purposeList.classList.add('purpose-checkbox-list__active')
      } else {
        purposeList.setAttribute('data-status', 'false')
        purposeList.classList.remove('purpose-checkbox-list__active')
      }
    })

    this.messagePopup.addEventListener('click', e => {
      const btnConfirm = e.target.closest('.btn-confirm')
      if (!btnConfirm) return
      this.messagePopup.classList.add('hide')
    })

    document
      .querySelector('.m-my-lists-alert-2')
      .addEventListener('click', e => {
        const btnConfirm = e.target.closest('.btn-confirm')
        if (!btnConfirm) return
        document.querySelector('.m-my-lists-alert-2').classList.add('hide')
      })

    this.btnBack.click(e => {
      e.preventDefault()
      this.resetLabelList()
      this.hidePurposeForm()
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/AddToList.js